import React from 'react';
import MaterialTable from 'material-table';
import { StockOrderStatusEnum, Status } from 'openapi';
import StatusColumn from '../labels/StatusColumn';
import OrderTypeChip from '../labels/OrderTypeChip';
import { useTranslation } from 'react-i18next';

interface Props {
    errorList: Status[],
}

export default ((props) => {
    const {t} = useTranslation();

    return (
        <MaterialTable
            title={t('errorList')}
            columns={[
                {
                    title: t('orderType'), field: 'orderType', editable: 'never',
                    render: data => <OrderTypeChip orderType={data ? data.orderType : -1} />,
                },
                { title: t('createdDate'), field: 'createdDate', type: 'date' },
                {
                    title: t('status'), field: 'orderStatus', editable: 'never',
                    render: data => <StatusColumn status={data ? data.status : StockOrderStatusEnum.Waiting} />,
                },
                { title: t('karteNo'), field: 'karteNo', type: 'numeric' },
                { title: t('messageCode'), field: 'messageCode' },
                { title: t('message'), field: 'message' },
            ]}
            data={props.errorList}
            options={{
                search: false,
                sorting: false,
                filtering: false,
                paging: false
            }}
        />
    );
}) as React.FC<Props>;
